import { render } from "./PriceRequests.vue?vue&type=template&id=b6c53d82&scoped=true"
import script from "./PriceRequests.vue?vue&type=script&lang=js"
export * from "./PriceRequests.vue?vue&type=script&lang=js"

import "./PriceRequests.vue?vue&type=style&index=0&id=b6c53d82&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6c53d82"]])

export default __exports__